module.exports = __webpack_public_path__ + "static/zhaopin-bd647e9f38539bebe379a22ca95b3d31.png";